// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';

import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

type Props = {
    resultCount?: number,
    isLoadingOrRedirecting: boolean
};

export const CAPPED_TOTAL = 300;

const MetaResultsCount = (props: Props) => {
    const {resultCount, isLoadingOrRedirecting} = props;

    if (isLoadingOrRedirecting) {
        return (
            <LoadingPlaceholder extraClasses="MetaResultsCount__placeholder" />
        );
    }

    if (!resultCount) {
        return <div className="MetaResultsCount" />;
    }

    return (
        <div className="MetaResultsCount">
            {resultCount > CAPPED_TOTAL ? (
                <FormattedMessage
                    id="propertyCountPlusLabel"
                    defaultMessage="{maxResultCount, plural, few {{maxResultCount}+ properties} many {{maxResultCount}+ properties} other {{maxResultCount}+ properties}}"
                    values={{
                        maxResultCount: CAPPED_TOTAL
                    }}
                />
            ) : (
                <FormattedMessage
                    id="propertyCountLabel"
                    defaultMessage="{resultCount, plural, zero {0 properties} one {1 property} few {# properties} many {# properties} other {# properties}}"
                    values={{
                        resultCount
                    }}
                />
            )}
        </div>
    );
};

MetaResultsCount.defaultProps = {
    isLoadingOrRedirecting: false
};

export default MetaResultsCount;
